import { createFileRoute, redirect } from "@tanstack/react-router";
// No matching blog category. Redirect to the Tile Roofing service page.
export const Route = createFileRoute("/category/tile-roofing")({
  beforeLoad: () => { throw redirect({ to: "/tile-roofing", statusCode: 301 }); },
});
